// extracted by mini-css-extract-plugin
export default {"component":"ReleaseMenuBanner_component__DyV0w","textBold":"ReleaseMenuBanner_textBold__9+X3N","darkMode":"ReleaseMenuBanner_darkMode__IK8YJ"};